import {ILeadModalConsultant} from "../../types/lead/ILeadModalConsultant";

const sylwia_72 = require("../../images/consultants/sylwia_czauderna_72x27.png");
const sylwia_144 = require("../../images/consultants/sylwia_czauderna_144x144.png");
const sylwia_216 = require("../../images/consultants/sylwia_czauderna_216x216.png");
const wiktoria_72 = require("../../images/consultants/wiktoria_mosciszko_72x27.png");
const wiktoria_144 = require("../../images/consultants/wiktoria_mosciszko_144x144.png");
const wiktoria_216 = require("../../images/consultants/wiktoria_mosciszko_216x216.png");
const roza_72 = require("../../images/consultants/roza_parzyszek_72x27.png");
const roza_144 = require("../../images/consultants/roza_parzyszek_144x144.png");
const roza_216 = require("../../images/consultants/roza_parzyszek_216x216.png");

const consultantList: ILeadModalConsultant[] = [
    {
        image: {s72: sylwia_72, s144: sylwia_144, s216: sylwia_216},
        gender: "female",
        fullName: "Sylwia Czauderna"
    },
    {
        image: {s72: wiktoria_72, s144: wiktoria_144, s216: wiktoria_216},
        gender: "female",
        fullName: "Wiktoria Mościszko"
    },
    {
        image: {s72: roza_72, s144: roza_144, s216: roza_216},
        gender: "female",
        fullName: "Róża Parzyszek"
    }
];

export function getRandomConsultant() {
    const randomIndex = Math.floor(Math.random() * consultantList.length);
    return consultantList[randomIndex];
}
import {ILeadModalConsultant} from "../../types/lead/ILeadModalConsultant";

const sylwia_72 = require("../../images/consultants/sylwia_czauderna_72x27.png");
const sylwia_144 = require("../../images/consultants/sylwia_czauderna_144x144.png");
const sylwia_216 = require("../../images/consultants/sylwia_czauderna_216x216.png");
const wiktoria_72 = require("../../images/consultants/wiktoria_mosciszko_72x27.png");
const wiktoria_144 = require("../../images/consultants/wiktoria_mosciszko_144x144.png");
const wiktoria_216 = require("../../images/consultants/wiktoria_mosciszko_216x216.png");
const roza_72 = require("../../images/consultants/roza_parzyszek_72x27.png");
const roza_144 = require("../../images/consultants/roza_parzyszek_144x144.png");
const roza_216 = require("../../images/consultants/roza_parzyszek_216x216.png");

const consultantList: ILeadModalConsultant[] = [
    {
        image: {s72: sylwia_72, s144: sylwia_144, s216: sylwia_216},
        gender: "female",
        fullName: "Sylwia Czauderna"
    },
    {
        image: {s72: wiktoria_72, s144: wiktoria_144, s216: wiktoria_216},
        gender: "female",
        fullName: "Wiktoria Mościszko"
    },
    {
        image: {s72: roza_72, s144: roza_144, s216: roza_216},
        gender: "female",
        fullName: "Róża Parzyszek"
    }
];

export function getRandomConsultant() {
    const randomIndex = Math.floor(Math.random() * consultantList.length);
    return consultantList[randomIndex];
}
